module.exports = __webpack_public_path__ + "img/IMG-20230301-WA0044.80c9b4b6.jpg";